import { useNavigate } from "@tanstack/react-router"

import { IntegrationCard } from "@productlane/ui"

import { SettingsHeader } from "../settings-header"
import {
	RECONNECT_TOOLTIP,
	useIntegrationConnections,
	useIntegrationReconnects,
	useVisibleIntegrations,
} from "./registry"

export function IntegrationsListPage() {
	const navigate = useNavigate()
	const integrations = useVisibleIntegrations()
	const connections = useIntegrationConnections()
	const reconnects = useIntegrationReconnects()

	return (
		<>
			<SettingsHeader
				title="Integrations"
				subtitle="Connect Productlane to the tools your team already uses."
			/>
			<div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
				{integrations.map((integration) => (
					<IntegrationCard
						key={integration.key}
						variant="grid"
						name={integration.title}
						description={integration.description}
						connected={connections[integration.key]}
						warning={
							reconnects[integration.key] ? RECONNECT_TOOLTIP : undefined
						}
						logo={<integration.Icon className="h-6 w-6" />}
						onClick={() => void navigate({ href: integration.href })}
					/>
				))}
			</div>
		</>
	)
}
